import { useEffect, useState } from "react";
import api from "../../../lib/api";

function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export default function TourListBlock({ data }) {
  const { title, limit } = data || {};
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/tours")
      .then((r) => {
        const upcoming = (r.data || [])
          .filter((t) => !t.date || new Date(t.date) >= new Date())
          .slice(0, Number(limit) || 3);
        setTours(upcoming);
      })
      .finally(() => setLoading(false));
  }, [limit]);

  if (loading) return <div className="py-12 text-center text-sm opacity-60">Lade Touren …</div>;
  if (!tours.length) return null;

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        {title && (
          <h2 className="font-display text-3xl md:text-4xl mb-8 tracking-tight" style={{ color: "var(--wp-text)" }}>
            {title}
          </h2>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {tours.map((t) => (
            <a key={t.id} href="/tours" className="plant-card p-5 block" data-testid={`tour-list-block-${t.id}`}>
              {t.image_url && (
                <div className="aspect-[16/10] overflow-hidden rounded-xl -m-5 mb-4">
                  <img src={t.image_url} alt={t.title} className="w-full h-full object-cover" />
                </div>
              )}
              <div className="overline mb-2">{fmtDate(t.date)}</div>
              <h3 className="font-display text-xl mb-1" style={{ color: "var(--wp-olive)" }}>{t.title}</h3>
              {t.location && (
                <div className="text-xs opacity-70 mb-2">
                  <i className="fa-solid fa-location-dot mr-1" /> {t.location}
                </div>
              )}
              {t.description && (
                <p className="text-sm line-clamp-3" style={{ color: "var(--wp-text-muted)" }}>{t.description}</p>
              )}
              <div className="mt-3 text-xs font-medium" style={{ color: "var(--wp-primary)" }}>
                {t.price ? `${t.price} € · ` : ""}{t.current_bookings || 0}/{t.max_participants || 12} Plätze
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
